import '@/App.css';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { WhatWeDo } from '@/components/WhatWeDo';
import { Machines } from '@/components/Machines';
import { HowItWorks } from '@/components/HowItWorks';
import { Reviews } from '@/components/Reviews';
import { ServiceArea } from '@/components/ServiceArea';
import { Contact } from '@/components/Contact';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Navbar />
      <Hero />
      <WhatWeDo />
      <Machines />
      <HowItWorks />
      <Reviews />
      <ServiceArea />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
